export default __webpack_public_path__ + "static/media/Moldura.392a1c11.svg";